// extracted by mini-css-extract-plugin
module.exports = {"action":"amb_b7","error":"amb_jz"};